import React from 'react';

import { isObject } from 'helpers/utils';

import LightOnfidoDoc from './LightInfidoDoc';

const LightOnfidoDocList = (props) => {
    return (
        <ul>
            {isObject(props.acceptableDocuments) &&
                props.acceptableDocuments.map((doc, i) => (
                    <LightOnfidoDoc
                        key={i}
                        type={doc.type}
                        userType={props.userType}
                        title={doc.title}
                        onClick={props.onClick}
                        subTitle={doc.subTitle}
                        userCountryId={props.userCountryId}
                        flagName={doc.issuedCountry}
                        userCountryInEEA={props.userCountryInEEA}
                    />
                ))}
        </ul>
    );
};
export default LightOnfidoDocList;
